import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { Children } from 'react';
import GridView from '../GridView';
import StepperProgressContext from './Context';
var ACTIVE_COLOR = 'primary-light';

function StepperProgress(_ref) {
  var activeStepIndex = _ref.activeStepIndex,
      _ref$activeColor = _ref.activeColor,
      activeColor = _ref$activeColor === void 0 ? ACTIVE_COLOR : _ref$activeColor,
      children = _ref.children,
      restProps = _objectWithoutPropertiesLoose(_ref, ["activeStepIndex", "activeColor", "children"]);

  return /*#__PURE__*/React.createElement(GridView, _extends({
    autoFlow: "column",
    autoColumns: "1fr",
    alignment: "center"
  }, restProps), Children.map(children, function (child, stepIndex) {
    return /*#__PURE__*/React.createElement(StepperProgressContext.Provider, {
      key: stepIndex,
      value: {
        activeColor: activeColor,
        active: stepIndex <= activeStepIndex,
        includeLine: stepIndex > 0
      }
    }, child);
  }));
}

export default StepperProgress;